import { buildLinkResetHeader, buildSocialIconTd } from './shared';

export default (brand) => ({
  id: 0,
  name: 'Template #1',
  height: 100,
  params: ['name', 'title', 'phone', 'mobile', 'email', 'website', 'facebook', 'instagram', 'linkedin', 'twitter'],
  source: `${buildLinkResetHeader({ text: brand.text })}

<table id="body" cellpadding="0" cellspacing="0" style="width: 530px;border-collapse: collapse;" width="530" border="0">
  <tr>
    <td valign="middle" style="width: 200px;padding-right: 12px;" width="200">
      <a href="{{ website }}" target="_blank" style="text-decoration: none;display: inline-block;">
        <img
          src="${brand.logoUrl}"
          alt="Company logo"
          style="width: 200px;height: auto;display: block;border: 0;outline: none;"
          width="200"
        >
      </a>
    </td>
    <td valign="middle" style="width: 304px;padding-left: 12px;border-left: 2px solid ${brand.primary};" width="304">
      <table
        cellpadding="0"
        cellspacing="0"
        style="width: 304px; line-height: 18px; mso-line-height-rule: exactly;"
        width="304"
        border="0"
      >
        {% if name %}
          <tr>
            <td style="color: ${brand.text}; font-size: 16px; font-family: Helvetica, Arial, sans-serif; line-height: 18px; mso-line-height-rule: exactly;">
              <b>{{- name -}}</b>
            </td>
          </tr>
        {% endif %}
        {% if title %}
          <tr>
            <td style="color: ${brand.text}; font-size: 13px; font-family: Helvetica, Arial, sans-serif; line-height: 18px; mso-line-height-rule: exactly;">
              <b>{{- title -}}</b>
            </td>
          </tr>
        {% endif %}
        <tr>
          <td
            nowrap
            style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif; line-height: 18px; mso-line-height-rule: exactly;"
          >
            {% if phone %}
              <a
                href="tel:{{phone}}"
                style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;white-space: nowrap;"
              >
                {{- phone -}}
              </a>
            {% endif %}
            {% if phone and mobile %}
              <span style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif;">|</span>
            {% endif %}
            {% if mobile %}
              <a
                href="tel:{{mobile}}"
                style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;white-space: nowrap;"
              >
                {{- mobile -}}
              </a>
            {% endif %}
          </td>
        </tr>
        <tr>
          <td
            nowrap
            style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif; line-height: 18px; mso-line-height-rule: exactly;"
          >
            {% if email %}
              <a
                href="mailto:{{email}}"
                style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;white-space: nowrap;"
              >
                {{- email -}}
              </a>
            {% endif %}
            {% if email and website %}
              <span style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif;">|</span>
            {% endif %}
            {% if website %}
              <a
                href="{{ website }}"
                style="color: ${brand.text} !important; font-size: 12px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;white-space: nowrap;"
              >
                {{- website -}}
              </a>
            {% endif %}
          </td>
        </tr>
        <tr>
          <td style="padding-top: 8px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
${buildSocialIconTd({ indent: 18, field: 'facebook', type: 'facebook', alt: 'facebook', background: brand.primaryNoHash, color: 'ffffff', radius: 100 })}
${buildSocialIconTd({ indent: 18, field: 'instagram', type: 'instagram', alt: 'instagram', background: brand.primaryNoHash, color: 'ffffff', radius: 100 })}
${buildSocialIconTd({ indent: 18, field: 'linkedin', type: 'linkedin', alt: 'linkedin', background: brand.primaryNoHash, color: 'ffffff', radius: 100 })}
${buildSocialIconTd({ indent: 18, field: 'twitter', type: 'x', alt: 'twitter', background: brand.primaryNoHash, color: 'ffffff', radius: 100 })}
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`
});
